export enum ActionTypeArticle {
  GetArticleDetail = 'GetArticleDetail'
}

export enum MutationTypeArticle {
  SetArticleDetail = 'SetArticleDetail',
  SetArticleDetailLoading = 'SetArticleDetailLoading',
  SetArticleDetailLoaded = 'SetArticleDetailLoaded'
}
